import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Modal, DeleteModal } from '@thinknet-gmbh/platform-common-ui';

import { COMPANY_PROFILE_MODALS } from 'src/pages/settings/components/company-profile/company-profile.constants';
import { useDeleteSubsidiaryCompanyById } from 'src/hooks/companies/delete-subsidiary-company-by-id.hook';
import { ROUTES } from 'src/components/app/app-routes.constants';

import { TransferEmployees } from './components/transfer-employees';

const companies: any[] = [];
const employees: any[] = [];

const DeleteSubsidiaryCompany = ({
  companyToDelete,
}: {
  companyToDelete: { _id: string; name: string };
}) => {
  const { t } = useTranslation('settings');
  const [activeModal, setActiveModal] = useState<null | string>(null);
  const [isCloseTransferModal, setCloseTransferModal] = useState(false);
  const navigate = useNavigate();

  const deleteSubsidiaryCompanyById = useDeleteSubsidiaryCompanyById({
    onSuccess: () => setActiveModal(null),
  });

  const closeModal = () => {
    setActiveModal(null);
    setCloseTransferModal(false);
  };

  const closeTransferModal = (forceClosing?: boolean) => {
    if (isCloseTransferModal || forceClosing) {
      closeModal();
    }

    setCloseTransferModal(!isCloseTransferModal);
  };

  const onSubmit = () => {
    deleteSubsidiaryCompanyById({ variables: { companyId: companyToDelete._id } });
    navigate(`${ROUTES.settings}`);
  };

  useEffect(() => {
    if (companyToDelete._id && employees.length) {
      setActiveModal(COMPANY_PROFILE_MODALS.transferEmployees);
    } else {
      setActiveModal(COMPANY_PROFILE_MODALS.deleteCompany);
    }
  }, [companyToDelete]);

  return (
    <div>
      {activeModal === COMPANY_PROFILE_MODALS.deleteCompany && (
        <DeleteModal
          isOpened
          onClose={closeModal}
          translate={t}
          title={t('settings:company.deleteSubsidiaryCompany.title')}
          subTitle={t('settings:company.deleteSubsidiaryCompany.subtitle', {
            companyName: companyToDelete.name,
          })}
          onSubmit={onSubmit}
        />
      )}
      {activeModal === COMPANY_PROFILE_MODALS.transferEmployees && (
        <Modal
          isOpened
          title={t('settings:company.labels.transferEmployees')}
          onClose={closeTransferModal}
          smallerPadding
        >
          <TransferEmployees
            companies={companies}
            employees={employees}
            companyId={companyToDelete._id}
            isCloseModalAttempt={isCloseTransferModal}
            closeModalAttempt={closeTransferModal}
          />
        </Modal>
      )}
    </div>
  );
};

export default DeleteSubsidiaryCompany;
